import { render, staticRenderFns } from "./pricing-beta.vue?vue&type=template&id=d32fcf72"
var script = {}
import style0 from "./pricing-beta.vue?vue&type=style&index=0&id=d32fcf72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports